<template>
  <div
    class="file-translate-entry"
    :class="[isShowHistoryRecord ? '' : 'full']"
  >
    <div class="add-file">+</div>
    <div class="text">AI文档翻译·问答</div>
    <div class="file-type">
      <div class="item" v-for="item in fileTypeList" :key="item.type">
        <img class="icon" :src="item.icon" />
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // 组件名称
  name: "FileTranslateEntry",
  props: {
    isShowHistoryRecord: {
      type: Boolean,
      default: false,
    },
  },
  // 变量声明
  data() {
    return {
      fileTypeList: [
        {
          type: "doc",
          name: "doc/docx",
          icon: require("../../assets/v2/img/trans/file-doc.png"),
        },

        {
          type: "excel",
          name: "xls/xlsx",
          icon: require("../../assets/v2/img/trans/file-xls.png"),
        },
        {
          type: "ppt",
          name: "doc/docx",
          icon: require("../../assets/v2/img/trans/file-ppt.png"),
        },
        {
          type: "txt",
          name: "txt",
          icon: require("../../assets/v2/img/trans/file-txt.png"),
        },
        {
          type: "xml",
          name: "xml/html/htm",
          icon: require("../../assets/v2/img/trans/file-xml.png"),
        },
        {
          type: "pdf",
          name: "pdf",
          icon: require("../../assets/v2/img/trans/file-pdf.png"),
        },
      ],
    };
  },
  watch: {},
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  mounted() {},
  // 方法
  methods: {},
};
</script>
<style lang="less" scoped>
.file-translate-entry {
  position: absolute;
  width: 460px;
  height: 210px;
  left: 30px;
  bottom: 60px;
  background: rgba(246, 248, 255, 0.42);
  border-radius: 10px;
  border: 1px dashed #dce1f0;
  cursor: pointer;
  &.full {
    left: 60px;
  }
  .add-file {
    width: 48px;
    height: 48px;
    background: #e5f0ff;
    border-radius: 50%;
    border: 1px dashed #dce1f0;
    font-size: 34px;
    color: var(--primary);
    text-align: center;
    line-height: 48px;
    margin: 25px auto 15px;
  }
  .text {
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    text-align: center;
    margin-bottom: 20px;
  }
  .file-type {
    display: flex;
    width: 100%;
    padding: 0 20px;
    gap: 0 20px;
    .item {
      text-align: center;
      .icon {
        width: 30px;
      }
      .name {
        font-size: 12px;
        color: #999999;
        line-height: 18px;
      }
    }
  }
}
</style>
  